import React from 'react'
import TimeSeriesWithBands from './renderer/timeSeriesWithBands'
import TimeSeriesComparison from './renderer/timeSeriesComparison'
import OutbreakDetectionPlot from './renderer/outbreakDetectionPlot'
import ButtonsPanel from './renderer/buttonPanel'
import { AnyVisualization, ButtonsPanelButton, VisualizationAlert } from './visualization.types'

interface VisualizationProps {
  visualization: AnyVisualization
  isExpanded: boolean
  activeButton?: string
  onButtonClick?: (button: ButtonsPanelButton) => void
  activeLabel?: string
  alert?: VisualizationAlert
  insightTitle?: string
}

export default function Visualization({
  visualization,
  isExpanded,
  activeButton,
  onButtonClick,
  activeLabel,
  alert,
  insightTitle,
}: VisualizationProps) {
  return (
    <div>
      {visualization.renderer === 'timeSeriesWithBands' && (
        <TimeSeriesWithBands
          visualization={visualization}
          isExpanded={isExpanded}
          alert={alert}
        />
      )}
      {visualization.renderer === 'timeSeriesComparison' && (
        <TimeSeriesComparison
          visualization={visualization}
          isExpanded={isExpanded}
          activeButton={activeButton}
          activeLabel={activeLabel}
          insightTitle={insightTitle}
        />
      )}
      {visualization.renderer === 'outbreakDetectionPlot' && (
        <OutbreakDetectionPlot
          visualization={visualization}
          isExpanded={isExpanded}
          alert={alert}
        />
      )}
      {visualization.renderer === 'buttons' && (
        <ButtonsPanel
          visualization={visualization}
          onButtonClick={onButtonClick}
        />
      )}
      {visualization.renderer === 'unknown' && <div>Unknown visualization renderer</div>}
    </div>
  )
}
